import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
/**
 * Minimal placeholder content:
 * Shows the active page name centered (per current scope).
 */
export default function CenteredPageName({ title }) {
    return (_jsx(Box, { sx: {
            minHeight: "calc(100vh - 120px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
        }, children: _jsx(Typography, { variant: "h5", sx: { fontWeight: 700 }, children: title }) }));
}
